import { bookingRefundOffers } from "../../../app/api/cancelBooking";
import { BaseAction } from "../../../core/actions/BaseAction";
import { IMultiBookingRefundSummary, IMoneySummary } from "../../../Orchestrator/Recoils/MultiBookingAtom";
import { IBookingResponse } from "../../../Orchestrator/Types/Index";
import { IRefundOfferRequest } from "../../../Orchestrator/Types/Types/BookingTypes";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";

export interface IGetMultiBookingRefundSummaryParams {
  booking: IBookingResponse | null;
}

export type IGetMultiBookingRefundSummaryResult = IMultiBookingRefundSummary | null;

class GetMultiBookingRefundSummaryAction extends BaseAction<
  IGetMultiBookingRefundSummaryResult,
  IGetMultiBookingRefundSummaryParams
> {
  override async run(): Promise<IGetMultiBookingRefundSummaryResult> {
    updateRecoilState("multiBookingRefundSummaryAtom", null);
    const booking = this.params?.booking;
    const bookingPayload = booking?.booking;

    if (!bookingPayload?.id) {
      throw new Error("BOOKING_NOT_FOUND");
    }

    const fulfillmentIds = this.collectFulfillmentIds(bookingPayload) || [];

    if (fulfillmentIds.length === 0) {
      throw new Error("NO_ELIGIBLE_FULFILLMENTS");
    }

    const payload: IRefundOfferRequest = {
      fulfillmentIds,
      overruleCode: null,
      refundDate: new Date().toISOString(),
    };

    const response = await bookingRefundOffers(payload, bookingPayload.id);
    if (response.status !== "ok" || !response.answer?.refundOffers?.length) {
      throw new Error("NO_REFUND_OFFERS");
    }

    const firstOffer = response.answer.refundOffers[0];
    const summary = {
      refundableAmount: (firstOffer?.refundableAmount as IMoneySummary) || null,
      refundFee: (firstOffer?.refundFee as IMoneySummary) || null,
    };
    updateRecoilState("multiBookingRefundSummaryAtom", summary);
    return summary;
  }

  private collectFulfillmentIds(bookingPayload: IBookingResponse["booking"]) {
    const ids = new Set<string>();
    const offers = bookingPayload?.bookedOffers || [];

    offers.forEach((offer: any) => {
      (offer?.admissions || []).forEach((admission: any) => {
        if (admission?.id && admission?.status !== "REFUNDED") {
          ids.add(admission.id);
        }
      });

      (offer?.ancillaries || []).forEach((ancillary: any) => {
        if (ancillary?.id && ancillary?.status !== "REFUNDED") {
          ids.add(ancillary.id);
        }
      });
    });

    return Array.from(ids);
  }
}

export const getMultiBookingRefundSummaryAction = new GetMultiBookingRefundSummaryAction();

